import { useTranslation } from '@lyearn/i18n';
import { SearchFill } from '@lyearn/icons';
import { EmptyState } from '@lyearn/molecules';
import { Stack, Typography } from '@lyearn/ui';

import { AsyncFilterSearchProps } from './types';

function FilterEmptyState({
  emptyLabel,
  search,
}: {
  emptyLabel?: string;
  search?: AsyncFilterSearchProps;
}) {
  const { t } = useTranslation();

  if (search?.value) {
    return (
      <Stack alignItems="center" className="h-full p-32" direction="col" justifyContent="center">
        <EmptyState
          Icon={SearchFill}
          description={t('Common:EmptyState.NoResultsSearchDescription')}
          primaryAction={{
            label: t('Common:EmptyState.ClearSearch'),
            onClick: () => search.onChange(''),
          }}
          title={t('Common:EmptyState.NoResultsSearch', { searchText: search.value })}
        />
      </Stack>
    );
  }

  return (
    <Typography
      className="px-20 py-16 xs:px-24"
      color="text-text-secondary"
      variant="body-short-02">
      {emptyLabel ?? t('Common:NoResultsFound')}
    </Typography>
  );
}

export default FilterEmptyState;
